import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'PickupCategory';

const PickupCategoryApi: any = baseApi(endpoint);

export default PickupCategoryApi;